import { pick } from 'ramda'

const SHARED_GENERAL_CARGO_FIELDS = [
  'price',
  'currency',
  'containerId',
  'weight',
  'cargoTypeId',
  'adrClassId',
  'europeanEmissionStandard'
]

export const getSharedGeneralCargoFields = offer =>
  pick(SHARED_GENERAL_CARGO_FIELDS, offer.toJS())
